import React, { useCallback, useEffect, useState } from "react";
import UserHeader from "./UserHeader";
import ProfileContainer from "./ProfileContainer";
import { Outlet } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axiosInsatnace, { getAllDashboardData } from "../../asiosConfig";

import { getDashboardJava } from "../../javaAxiosConfig";

import { CircularProgress } from "@mui/material";
import PremiumModal from "./PremiumModal";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../services/firebaseConfig";

export const Layout = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const currentUsername = localStorage.getItem("username");
  useEffect(() => {
    const fetchUnreadMessages = () => {
      // Firestore query for conversations
      const q = query(
        collection(db, "conversations"),
        where("lastMessage.status", "==", "sent"),
      );

      // Real-time listener for updates
      const unsubscribe = onSnapshot(q, (snapshot) => {
        let count = 0;

        snapshot.forEach((doc) => {
          const data = doc.data();
          const lastMessage = data.lastMessage;

          // Check if the current user is part of the conversation
          if (
            lastMessage &&
            lastMessage.senderId !== currentUsername &&
            (data.participants?.includes(currentUsername) ||
              data.receiverId === currentUsername)
          ) {
            count++; // Increment count for unread messages in relevant conversations
          }
        });

        setUnreadCount(count); // Update unread count state
      });

      return unsubscribe; // Cleanup listener
    };

    const unsubscribe = fetchUnreadMessages();
    return () => unsubscribe(); // Cleanup on unmount
  }, [currentUsername]);

  const dashboardFetchedRef = React.useRef(false);

  const fetchDashboard = useCallback(async () => {
    if (dashboardFetchedRef.current) return;
    dashboardFetchedRef.current = true;

    try {
      const response = await getDashboardJava({
        app_version: "1.7.0",
        active_platform: "web",
      });

      if (response.status === 200 && response.data?.success) {
        const user = response.data.data;

        // 🔹 STORE FOR HEADER
        localStorage.setItem("full_name", user.name || "");
        localStorage.setItem("username", user.username || "");

        localStorage.setItem("mobileNumber", user.mobileNumber || "");
        // console.log("[DASHBOARD] user mobileNumber stored:", user.mobileNumber);

        // localStorage.setItem("userId", user.id);
        localStorage.setItem("userId", user.user_id);
        // console.log("[DASHBOARD] userId stored:", user.user_id);

        localStorage.setItem(
          "membership_type",
          response.data.data.membershipType,
        );
        // console.log("[DASHBOARD] memmership type stored:",  response.data.data.membershipType);

        localStorage.setItem("profilePic", user.photo || "null");
        localStorage.setItem("account_type", user.membershipType || "Free");

        // 🔹 DERIVE GENDER
        if (user.username) {
          const gender = user.username.charAt(0); // M / F
          if (gender === "M" || gender === "F") {
            localStorage.setItem("gender", gender);
          }
        }

        // 🔹 SAVE TO STATE (if ProfileContainer needs it)
        setProfileData({
          name: user.name,
          username: user.username,
          photo: user.photo,
          membership_type: user.membershipType,
          package_expiry_date: user.package_expiry,
        });

        // 🔹 EXPIRY POPUP LOGIC
        if (user.package_expiry) {
          const expiryDate = new Date(user.package_expiry);
          const diffInDays = Math.ceil(
            (expiryDate - new Date()) / (1000 * 60 * 60 * 24),
          );

          if (diffInDays <= 7 && diffInDays >= 0) {
            const today = new Date().toDateString();
            if (localStorage.getItem("lastPopupDate") !== today) {
              setShowPopup(true);
              localStorage.setItem("lastPopupDate", today);
            }
          }
        }
      }
    } catch (error) {
      console.error("Dashboard error:", error?.response?.data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  const handleClosePopup = () => setShowPopup(false);

  if (loading) return <CircularProgress />;

  return (
    <div
      style={{
        background: "#F1F7FE ",
        padding: "8rem 0 1rem",
        minHeight: "100vh",
      }}
    >
      <UserHeader />
      <section className="middelBlock">
        <div className="container">
          <div className="row" style={{}}>
            <ProfileContainer
              profileData={profileData}
              unreadCount={unreadCount}
            />
            <Outlet replace />
          </div>
        </div>
      </section>

      {showPopup && (
        <PremiumModal
          onClose={handleClosePopup}
          daysLeft={Math.ceil(
            (new Date(profileData?.package_expiry_date) - new Date()) /
              (1000 * 60 * 60 * 24),
          )}
        />
      )}

      {/* <ToastContainer /> */}
    </div>
  );
};
